import React from 'react';

export default () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="24" fill="#1E366C"><path d="M0 .079l17.195 12.375L0 23.12V.079zm1.071 2.405v18.553l14.026-8.606L1.07 2.484z"/></svg>;
